import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { PuntoEncuentroFullSchema, PuntoVentaFullSchema, SucursalFullSchema, } from '@/data/dto/sucursalAdmin';
function desenvolver(data, schema) {
    if (Array.isArray(data))
        return z.array(schema).parse(data);
    return z.object({ items: z.array(schema) }).parse(data).items;
}
function limpiarSucursal(v) {
    return {
        nombre: v.nombre,
        direccion: v.direccion || null,
        telefono: v.telefono || null,
        email: v.email || null,
    };
}
function limpiarMp(v) {
    return {
        nombre: v.nombre,
        referencia: v.referencia || null,
        lat: v.lat ? Number(v.lat) : null,
        lng: v.lng ? Number(v.lng) : null,
    };
}
export const organizacionApi = {
    // --- Sucursales ---
    async listarSucursales() {
        const res = await apiClient.get(ENDPOINTS.sucursales);
        return desenvolver(res.data, SucursalFullSchema);
    },
    async crearSucursal(v) {
        const res = await apiClient.post(ENDPOINTS.sucursales, limpiarSucursal(v));
        return SucursalFullSchema.parse(res.data);
    },
    async editarSucursal(id, v) {
        const res = await apiClient.patch(`${ENDPOINTS.sucursales}/${id}`, limpiarSucursal(v));
        return SucursalFullSchema.parse(res.data);
    },
    async desactivarSucursal(id) {
        await apiClient.delete(`${ENDPOINTS.sucursales}/${id}`);
    },
    // --- PDV ---
    async listarPdv(sucursalId) {
        const res = await apiClient.get(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-venta`);
        return desenvolver(res.data, PuntoVentaFullSchema);
    },
    async crearPdv(sucursalId, v) {
        const res = await apiClient.post(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-venta`, {
            nombre: v.nombre,
            descripcion: v.descripcion || null,
        });
        return PuntoVentaFullSchema.parse(res.data);
    },
    async editarPdv(sucursalId, pdvId, v) {
        const res = await apiClient.patch(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-venta/${pdvId}`, {
            nombre: v.nombre,
            descripcion: v.descripcion || null,
        });
        return PuntoVentaFullSchema.parse(res.data);
    },
    async desactivarPdv(sucursalId, pdvId) {
        await apiClient.delete(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-venta/${pdvId}`);
    },
    // --- Meeting points ---
    async listarMp(sucursalId) {
        const res = await apiClient.get(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-encuentro`);
        return desenvolver(res.data, PuntoEncuentroFullSchema);
    },
    async crearMp(sucursalId, v) {
        const res = await apiClient.post(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-encuentro`, limpiarMp(v));
        return PuntoEncuentroFullSchema.parse(res.data);
    },
    async editarMp(sucursalId, mpId, v) {
        const res = await apiClient.patch(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-encuentro/${mpId}`, limpiarMp(v));
        return PuntoEncuentroFullSchema.parse(res.data);
    },
    async desactivarMp(sucursalId, mpId) {
        await apiClient.delete(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-encuentro/${mpId}`);
    },
};
